import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { RedoOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { UTILS } from "utils";
import { API } from "api";

import OrderTabs from "../components/OrderTabs";
import useOrder from "hooks/useOrder";
import { LogisticAction } from "redux/actions";
import OrderRejectForm from "../components/OrderRejectForm";
import { errorHandler } from "api/api/errorHandler";
import useRefundableOrder from "hooks/useRefundableOrders";
import useGetORderByStatus from "../hooks/useGetORderByStatus";
import OrderTable from "../components/OrderTable"
import AppContainer from "components/ui/AppContainer";
import AppOutlineButton from "components/ui/AppOutlineButton";
import AppSearchInput from "components/ui/AppSearchInput";
import OrderDetailsModal from "../components/OrderDetailsModal";
import { useGetOrderInfoByIdMutation } from "redux/Logistic/LogisticService";
import AppModal from "components/ui/AppModal";
import { useMatchMediaDimensions } from "hooks/useWindowDimensions";

const LiveOrders = () => {
  const isMatch1300 = useMatchMediaDimensions(1300)
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState({});
  const [orderDetails, setOrderDetails] = useState({});
  const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  
  const [rejectReason, setRejectReason] = useState({
    values: {
      Modal: false,
      reason: null,
      isRefundRequired: false,
      type: null,
    },
    errors: {
      Modal: null,
      reason: null,
      logisticPartner: null,
    },
  });
  const [tabStatus, setTabStatus] = useState("PENDING");
  const [currentOrderId, setCurrentOrderId] = useState();
  const audio = new Audio(
    "https://uapp-live-com.s3.amazonaws.com/UAPP-MEDIA/PENDING_ORDER_MUSIC.mpeg"
  );
  const { t } = useTranslation();
  const { data } = useOrder();
  const [fetchOrderById] = useGetOrderInfoByIdMutation();

  const refreshOrderForModal = useCallback(
    async (orderId) => {
      if (!orderId) return;
      const userDetail = UTILS.getCurrentUser();
      const { data: result } = await fetchOrderById({
        orderId,
        brandId: userDetail.brandId,
      });
      if (result?.success === 1) {
        const fetched = result.data.fetchedOrder;
        setOrderDetails(fetched);
        setOrder(fetched);
        dispatch(LogisticAction.setOrderInfo(fetched));
      } else {
        UTILS.errorNotification(t("Please try again later!"));
      }
      setLoading(false);
    },
    [dispatch, fetchOrderById, t]
  );

  const { data: refundableOrdersCountData, revalidate: refundableMutate } =
    useRefundableOrder();

  const getPendingOrders = (status) => {
    if (
      UTILS.isValidObject(["pendingOrdersCount"], data?.data) &&
      Array.isArray(data?.data.pendingOrdersCount)
    ) {
      for (
        let index = 0;
        index < data?.data.pendingOrdersCount.length;
        index++
      ) {
        const element = data?.data.pendingOrdersCount[index];
        if (
          UTILS.isValidObject(["orderStatus"], element) &&
          element.orderStatus === status
        ) {
          return element.count;
        }
      }
      return 0;
    }
  };

  const getRefundableOrders = () => {
    if (
      UTILS.isValidObject(["refundableOrdersCount"], data?.data) &&
      Array.isArray(data?.data.refundableOrdersCount)
    ) {
      return data?.data.refundableOrdersCount.reduce((acc, statusCount) => {
        return statusCount.count + acc;
      }, 0);
    }
  };

  const checkPendingOrdersCount = (status) => {
    const count = getPendingOrders(status);
    if (count > 0) {
    }
    return count;
  };

  const checkRefundableOrdersCount = (status) => {
    const count = getRefundableOrders();
    if (count > 0) {
    }
    return count;
  };

  checkRefundableOrdersCount();

  checkPendingOrdersCount("PENDING");

  const getOrdersByStatus = useGetORderByStatus(
    setLoading,
    tabStatus,
    setOrders,
    setCurrentOrderId
  );

  useEffect(() => {
    console.log("tabStatus", tabStatus);
    getOrdersByStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabStatus]);

  const openOrderDetailsModal = (data) => {
    setOrderDetails(data);
    setOrder(data);
    setCurrentOrderId(data?._id);
    dispatch(LogisticAction.setOrderInfo(data));
    setShowOrderDetailsModal(true);
  };

  useEffect(() => {
    if (
      Array.isArray(orders) &&
      orders.length > 0 &&
      orders.length < getPendingOrders(tabStatus)
    ) {
      getOrdersByStatus();
    }
  }, [data]);

  

  const validateRejectReason = (type) => {
    if (type === "REJECT") {
      if (!rejectReason?.values?.reason) {
        handleErrors("reason", t("Reason is a required field"));
        return false;
      }
      if (rejectReason?.values?.reason?.trim()?.length <= 2) {
        handleErrors("reason", t("Reason must be atleast 3 characters long"));
        return false;
      }
      return true;
    }
    return true;
  };

  const onSubmit = async (status, type) => {
    try {
      if (!validateRejectReason(type)) return false;
      const userDetail = UTILS.getCurrentUser();
      setLoading(true);
      let obj = {
        brandId: userDetail.brandId,
        token: userDetail.token,
        orderId: currentOrderId,
        isRefundRequired: rejectReason.values?.isRefundRequired,
        orderStatus: type === "REJECT" ? rejectReason.values?.type : status,

        ...(type === "REJECT" &&
          rejectReason.values?.type === "REJECTED" && {
            cancelOrderReason: null,
            rejectedOrderReason: rejectReason.values.reason,
          }),
        ...(type === "REJECT" &&
          rejectReason.values?.type === "CANCELLED" && {
            cancelOrderReason: rejectReason.values.reason,
            rejectedOrderReason: null,
          }),
        language: "EN",
      };
      const result = await API.SET_ORDER_STATUS(obj);
      if (result?.success === 1) {
        if (type === "REJECT") {
          setRejectReason((prevState) => ({
            ...prevState,
            values: {
              ...prevState.values,
              Modal: false,
              reason: null,
              isRefundRequired: false,
            },
          }));
          refundableMutate("order/get-refundable-orders-count", {
            revalidate: true,
          });
          setShowOrderDetailsModal(false);
        }
        UTILS.successNotification(t("Order Updated!"));
      } else {
        UTILS.errorNotification(errorHandler(result?.error));
      }
      if (status === "PREPARING") audio.pause();
      await getOrdersByStatus("SCHEDULED");
      return result?.success === 1;
    } catch (error) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleValues = (key, value) => {
    setRejectReason((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: value,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const handleErrors = (key, value) => {
    setRejectReason((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
      },
      errors: {
        ...prevState.errors,
        [key]: value,
      },
    }));
  };

  const closeRejectModal = () => {
    setRejectReason((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        Modal: false,
        reason: null,
        isRefundRequired: false,
      },
      errors: {
        ...prevState.errors,
        reason: null,
      },
    }));
  };
  
  return (
    <AppContainer loading={loading}>
          <div
            className={`my-3 flex shrink-0 min-w-0 w-full flex-wrap gap-3 ${isMatch1300 ? "items-end" : "md:items-center"} justify-between md:gap-4`}
          >
              <OrderTabs
                orderCountData={data?.data}
                refundableOrdersCountData={refundableOrdersCountData}
                refundableMutate={refundableMutate}
                handleTabStatus={(status) => setTabStatus(status)}
                loading={loading}
              />
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3 md:justify-end">
              <div className="w-64">
                <AppSearchInput
                  value={searchTerm}
                  placeholder={t("Search by order number")}
                  onInput={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <AppOutlineButton
                className="w-full shrink-0 sm:w-auto"
                onClick={() => getOrdersByStatus("PENDING")}
              >
                <RedoOutlined />
                <span className="ps-1">{t("Load Orders")}</span>
              </AppOutlineButton>
            </div>
          </div>
          <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col">
            <OrderTable
              data={orders}
              searchTerm={searchTerm}
              onShowDetails={(row) => openOrderDetailsModal(row)}
            />
          </div>
          <OrderDetailsModal
            open={showOrderDetailsModal}
            onClose={() => setShowOrderDetailsModal(false)}
            description={orderDetails}
            tabStatus={tabStatus}
            setRejectReason={setRejectReason}
            onSubmit={onSubmit}
            getOrdersByStatus={getOrdersByStatus}
            refundableMutate={refundableMutate}
            setLoading={setLoading}
            getOrderInfoById={refreshOrderForModal}
          />

          <AppModal
            open={rejectReason.values.Modal}
            onClose={closeRejectModal}
            width={520}
            title={`${
              rejectReason.values?.type === "CANCELLED"
                ? t("Cancel Order")
                : t("Reject Order")
            } #${order?.orderNumber || ""}`}
          >
            <OrderRejectForm
              loading={loading}
              currentOrderId={currentOrderId}
              order={order}
              handleErrors={handleErrors}
              closeModal={closeRejectModal}
              handleValues={handleValues}
              {...{ rejectReason, onSubmit }}
            />
          </AppModal>

    </AppContainer>
  );
};
LiveOrders.propTypes = {
  status: PropTypes.string,
  color: PropTypes.string,
};
export default LiveOrders;
